import "./index.css";
import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
const container = document.getElementById("root");
if (!container) throw new Error("Root element not found");
createRoot(container).render(<App data-id="element-109" />);